/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateHtmlPageConfigReqVo
 */
export interface CreateHtmlPageConfigReqVo {
    /**
     * 页面名称
     * @type {string}
     * @memberof CreateHtmlPageConfigReqVo
     */
    pageName: string;
    /**
     * 内容（韩文）
     * @type {string}
     * @memberof CreateHtmlPageConfigReqVo
     */
    content: string;
    /**
     * 内容（中文）
     * @type {string}
     * @memberof CreateHtmlPageConfigReqVo
     */
    contentCn: string;
    /**
     * 排序
     * @type {number}
     * @memberof CreateHtmlPageConfigReqVo
     */
    sort?: number;
    /**
     * 是否可用：0-不可用，1-可用
     * @type {number}
     * @memberof CreateHtmlPageConfigReqVo
     */
    enable: number;
    /**
     * 页面区域类型：1-服务条款，2-个人信息搜集和使用信息，3-页面底部公司信息，4-客服联系信息，5-下单须知
     * @type {number}
     * @memberof CreateHtmlPageConfigReqVo
     */
    pageType: number;
    /**
     * 适用订单类型列表，仅下单须知页面使用
     * @type {Array<number>}
     * @memberof CreateHtmlPageConfigReqVo
     */
    orderType?: Array<number>;
}

/**
 * Check if a given object implements the CreateHtmlPageConfigReqVo interface.
 */
export function instanceOfCreateHtmlPageConfigReqVo(value: object): value is CreateHtmlPageConfigReqVo {
    if (!('pageName' in value) || value['pageName'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('contentCn' in value) || value['contentCn'] === undefined) return false;
    if (!('enable' in value) || value['enable'] === undefined) return false;
    if (!('pageType' in value) || value['pageType'] === undefined) return false;
    return true;
}

export function CreateHtmlPageConfigReqVoFromJSON(json: any): CreateHtmlPageConfigReqVo {
    return CreateHtmlPageConfigReqVoFromJSONTyped(json, false);
}

export function CreateHtmlPageConfigReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateHtmlPageConfigReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'pageName': json['pageName'],
        'content': json['content'],
        'contentCn': json['contentCn'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'enable': json['enable'],
        'pageType': json['pageType'],
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
    };
}

export function CreateHtmlPageConfigReqVoToJSON(json: any): CreateHtmlPageConfigReqVo {
    return CreateHtmlPageConfigReqVoToJSONTyped(json, false);
}

export function CreateHtmlPageConfigReqVoToJSONTyped(value?: CreateHtmlPageConfigReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageName': value['pageName'],
        'content': value['content'],
        'contentCn': value['contentCn'],
        'sort': value['sort'],
        'enable': value['enable'],
        'pageType': value['pageType'],
        'orderType': value['orderType'],
    };
}

